import { Checkbox, CheckboxProps } from '@easyv/react-components';
import * as React from 'react';

type ProCheckboxProps<T = unknown> = Omit<CheckboxProps, 'value' | 'OnChange'> &
  (
    | {
        checked: T;
        onChange: (v: T) => void;
        overrideValue: [trueValue: T, falseValue: T];
      }
    | { checked: boolean; onChange: (v: boolean) => void; overrideValue?: never }
  );

/** 支持checked表示非boolean值 */
export const ProCheckbox: React.FC<ProCheckboxProps> = (props) => {
  const { overrideValue, checked, onChange, ...rest } = props;

  if (!overrideValue) {
    return <Checkbox checked={checked} onChange={onChange} {...rest} />;
  }

  const [trueValue, falseValue] = overrideValue;

  const handleChange = (value: boolean) => {
    value ? onChange(trueValue) : onChange(falseValue);
  };

  const isChecked = checked === trueValue ? true : false;

  return <Checkbox checked={isChecked} onChange={handleChange} {...rest} />;
};
